import Header from '@/components/Header'
import Footer from '@/components/Footer'
import Breadcrumb from '@/components/Breadcrumb'
import CTABanner from '@/components/CTABanner'
import MetaTags from '@/components/MetaTags'
import SEOSchemaMarkup from '@/components/SEOSchemaMarkup'
import {
  Accordion,
  AccordionContent,
  AccordionItem,
  AccordionTrigger,
} from '@/components/ui/accordion'

const FAQ = () => {
  const faqData = [
    {
      question: 'Como funciona o processo de compra até a entrega?',
      answer:
        '1. Escolha e compre: selecione a linha de álbum e finalize a compra.\n2. Organize as fotos: reúna todas as imagens em uma única pasta em seu computador ou celular.\n3. Envie as fotos: faça o upload das imagens na plataforma.\n4. Verifique se todas as imagens foram enviadas e finalize a seleção.\n5. Curadoria e edição: nosso time seleciona e edita as imagens.\n6. Envio do layout para revisão: você receberá um e-mail para acessar seu layout, podendo solicitar alterações e ajustes.\n7. Finalize a revisão para que o designer receba as alterações.\n8. Impressão e entrega: após a aprovação final do layout, o álbum é produzido e entregue no endereço cadastrado.',
    },
    {
      question:
        'Estou em dúvida na quantidade de páginas ou de imagens para o álbum.',
      answer:
        'A quantidade de páginas varia de acordo com a linha escolhida. Todos os fotolivros começam com 20 páginas. Na linha LÚMINA, os álbuns vão de 20 a 48 páginas no máximo, enquanto nas linhas INSPIRAÇÃO, VIRTUOSE e MAGNIFIQUE a quantidade varia de 20 a 80 páginas no máximo.\n\nEstá em dúvida sobre a quantidade de páginas? Você pode adquirir um álbum com 20 páginas e, durante o processo de personalização, comprar páginas extras conforme a necessidade da sua história.',
    },
    {
      question: 'Tenho muitas fotos, não consigo escolher as melhores.',
      answer:
        'Tem muitas fotos e não consegue escolher as melhores? Você pode usufruir do nosso serviço de Curadoria de Fotos para a seleção de até 500 imagens. Um profissional fará a escolha das melhores fotos, com um olhar técnico e sensível, valorizando a narrativa do seu álbum. Caso você tenha mais de 500 fotos para selecionar, é possível contratar a curadoria adicional mediante uma pequena taxa.',
    },
    {
      question: 'Como envio as fotos?',
      answer:
        "Acesse sua área de pedidos e clique em 'Upload' para enviar as imagens. Você pode fazer isso em etapas, mas é importante finalizar a seleção para que o processo inicie.",
    },
    {
      question: 'Posso enviar fotos tiradas com celular?',
      answer:
        'Sim! Imagens feitas com celulares modernos são bem-vindas. Se forem de celulares antigos, faremos o possível para melhorar a qualidade.',
    },
    {
      question:
        'Tem sentido enviar as imagens amadoras que os familiares e amigos tiraram?',
      answer:
        'Faz muito sentido e pode trazer uma linguagem complementar ao seu álbum. Observe se a imagem está bem iluminada, nítida e com uma qualidade mínima para estar ao lado das imagens profissionais.',
    },
    {
      question: 'Preciso tratar as imagens antes?',
      answer:
        'Não. Nossa equipe profissional edita todas as fotos: amenizamos imperfeições de pele, melhoramos a condição de luz, equalizamos cores, diminuímos ruídos noturnos e ajustamos brilho e nitidez. Se a imagem permitir, retiramos pessoas ou objetos indesejados.',
    },
    {
      question: 'Como informo os detalhes que desejo no meu álbum?',
      answer:
        'Clique em Acessar produtos. Ao lado do nome do produto adquirido, clique no ícone do lápis. Será aberta uma tela para que você possa customizar seu álbum.\n\nBasta escrever no campo indicado o que você deseja, por exemplo: nome que gostaria na capa, datas, informações sobre a sequência dos eventos, frases importantes, entre outros. Isso ajuda o designer a ser mais assertivo na produção do layout do seu álbum.',
    },
    {
      question: 'Não consigo logar para revisar meu álbum',
      answer:
        'Caso tenha esquecido a senha, basta clicar em "Esqueci a senha", informar seu e-mail e aguardar cerca de 3 minutos. Clique em Enviar apenas uma vez e aguarde. Caso tenha clicado mais de uma vez, acesse apenas o último e-mail recebido em sua caixa de entrada.',
    },
    {
      question: 'Como funciona a revisão do álbum?',
      answer:
        'Após receber o e-mail, você irá acessar a plataforma com seu login e senha. Em seguida, clique em Revisão do Álbum e aprove ou reprove cada página. Em caso de reprovação, escreva o que deseja alterar em cada página.',
    },
    {
      question: 'Aprovarei o álbum antes da impressão?',
      answer:
        'Sim! Você receberá uma prova digital para revisão. As linhas Inspiração e Virtuose têm até duas revisões incluídas.',
    },
    {
      question: "Trabalham com imagens com marca d'água?",
      answer:
        "Não editamos imagens com marca d'água. Entendemos que você detém o direito sobre todas as imagens que fizer upload e selecionar para seu álbum.",
    },
    {
      question:
        'E se ultrapassar o prazo de 12 meses para enviar fotos e aprovar o álbum?',
      answer:
        'Você não perde o valor pago. Haverá apenas uma taxa de atualização conforme regras no manual.',
    },
    {
      question: 'Qual o prazo de entrega?',
      answer:
        'Após a aprovação final do layout, o álbum é produzido em até 15 dias úteis e enviado diretamente ao seu endereço.',
    },
    {
      question: 'Preciso de ajuda, como entro em contato?',
      answer:
        'Nossa equipe está à disposição via WhatsApp ou email para suporte sempre que precisar:\n(41) 99198-5765\natendimento@fotolivro.store',
    },
  ]

  const whatsappNumber = '554137950568'
  const whatsappMessage = encodeURIComponent(
    'Olá! Gostaria de saber mais sobre os fotolivros.',
  )

  return (
    <>
      <MetaTags
        title="Perguntas Frequentes (FAQ) - FotoLivro Store"
        description="Tire suas dúvidas sobre nossos fotolivros personalizados: prazos, formatos, personalização, envio, pagamento e mais. Atendimento especializado."
        type="website"
        keywords="faq fotolivro, dúvidas fotolivro, prazo fotolivro, como funciona fotolivro, perguntas frequentes álbum de fotos"
      />
      <SEOSchemaMarkup type="faq" faqData={faqData} />

      <div className="min-h-screen flex flex-col">
        <Header />
        <Breadcrumb />
        <main
          className="flex-1 bg-background"
          role="main"
          aria-label="Perguntas Frequentes"
        >
          <article className="container mx-auto px-4 py-16 max-w-4xl">
            <header className="text-center mb-12">
              <h1 className="text-4xl md:text-5xl font-bold text-foreground mb-4">
                Perguntas Frequentes
              </h1>
              <p className="text-lg text-muted-foreground">
                Tire suas dúvidas sobre nossos fotolivros personalizados
              </p>
            </header>

            <section aria-label="Lista de perguntas frequentes">
              <Accordion type="single" collapsible className="w-full">
                {faqData.map((item, index) => (
                  <AccordionItem key={index} value={`item-${index}`}>
                    <AccordionTrigger className="text-left text-lg font-semibold">
                      {item.question}
                    </AccordionTrigger>
                    <AccordionContent className="text-muted-foreground leading-relaxed whitespace-pre-line">
                      {item.answer}
                    </AccordionContent>
                  </AccordionItem>
                ))}
              </Accordion>
            </section>

            <section
              className="mt-12 p-6 bg-muted rounded-lg text-center"
              aria-label="Contato adicional"
            >
              <h2 className="text-xl font-semibold mb-2">
                Precisa de mais informações?
              </h2>
              <p className="text-muted-foreground mb-4">
                Entre em contato conosco pelo WhatsApp ou e-mail
              </p>
              <div className="flex flex-col sm:flex-row gap-4 justify-center">
                <a
                  href={`https://wa.me/${whatsappNumber}?text=${whatsappMessage}`}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="inline-flex items-center justify-center gap-2 px-6 py-3 bg-[#25D366] text-white rounded-md hover:bg-[#128C7E] transition-colors focus:outline-none focus:ring-2 focus:ring-[#25D366] focus:ring-offset-2"
                  aria-label="Entrar em contato via WhatsApp"
                >
                  <svg
                    className="h-5 w-5"
                    viewBox="0 0 24 24"
                    fill="currentColor"
                    aria-hidden="true"
                  >
                    <path d="M17.472 14.382c-.297-.149-1.758-.867-2.03-.967-.273-.099-.471-.148-.67.15-.197.297-.767.966-.94 1.164-.173.199-.347.223-.644.075-.297-.15-1.255-.463-2.39-1.475-.883-.788-1.48-1.761-1.653-2.059-.173-.297-.018-.458.13-.606.134-.133.298-.347.446-.52.149-.174.198-.298.298-.497.099-.198.05-.371-.025-.52-.075-.149-.669-1.612-.916-2.207-.242-.579-.487-.5-.669-.51-.173-.008-.371-.01-.57-.01-.198 0-.52.074-.792.372-.272.297-1.04 1.016-1.04 2.479 0 1.462 1.065 2.875 1.213 3.074.149.198 2.096 3.2 5.077 4.487.709.306 1.262.489 1.694.625.712.227 1.36.195 1.871.118.571-.085 1.758-.719 2.006-1.413.248-.694.248-1.289.173-1.413-.074-.124-.272-.198-.57-.347m-5.421 7.403h-.004a9.87 9.87 0 01-5.031-1.378l-.361-.214-3.741.982.998-3.648-.235-.374a9.86 9.86 0 01-1.51-5.26c.001-5.45 4.436-9.884 9.888-9.884 2.64 0 5.122 1.03 6.988 2.898a9.825 9.825 0 012.893 6.994c-.003 5.45-4.437 9.884-9.885 9.884m8.413-18.297A11.815 11.815 0 0012.05 0C5.495 0 .16 5.335.157 11.892c0 2.096.547 4.142 1.588 5.945L.057 24l6.305-1.654a11.882 11.882 0 005.683 1.448h.005c6.554 0 11.89-5.335 11.893-11.893a11.821 11.821 0 00-3.48-8.413Z" />
                  </svg>
                  WhatsApp
                </a>
                <a
                  href="mailto:atendimento@fotolivro.store"
                  className="inline-flex items-center justify-center gap-2 px-6 py-3 bg-primary text-primary-foreground rounded-md hover:bg-primary/90 transition-colors focus:outline-none focus:ring-2 focus:ring-primary focus:ring-offset-2"
                  aria-label="Enviar e-mail"
                >
                  E-mail
                </a>
              </div>
            </section>
          </article>
        </main>
        <Footer />
      </div>
    </>
  )
}

export default FAQ
